import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import ReactHookFields from "../../components/shared/ReactHookForm";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import useHomeValidateSchema from "./utils/useLoginValidateSchema";
import { MESSAGE } from "../../message";
import appConfig from "../../config/env";
import useRedirect from "../../helper/direct";
import { PATH } from "../../helper/path";
import { enqueueSnackbar } from "notistack";
import useAuthGlobal from "../../context/useAuthGlobal";
import useUserMe from "../../hooks/me/useUserMe";
import LoadingComp from "../../components/shared/LoadingComp";

export default function LoginTable() {
  const { setUserMe, userMe: userMeAuth } = useAuthGlobal();
  const { data: userMe, isLoading } = useUserMe();
  const [loadingAuth, setLoadingAuth] = useState(true);
  const { loginFieldList, validationSchema, loginObject } = useHomeValidateSchema();
  const redirect = useRedirect();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: loginObject,
    shouldUnregister: false,
  });

  const fetchCurrentUser = async (token) => {
    const response = await fetch(`${appConfig.API_HOST}/api/v1/auth/me`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to load user profile");
    }

    const result = await response.json();
    if (!result?.success || !result?.data) {
      throw new Error(result?.error?.message || "Failed to load user profile");
    }

    return result.data;
  };

  const handleLogin = async (data) => {
    try {
      const response = await fetch(`${appConfig.API_HOST}/api/v1/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      const result = await response.json();

      if (!response.ok) {
        return enqueueSnackbar(result?.message, { variant: "error" });
      }
      if (result?.statusCode === 200 && result?.data?.token) {
        const token = result.data.token;
        localStorage.setItem("token", token);
        const currentUser = await fetchCurrentUser(token);
        setUserMe(currentUser);
        redirect(PATH.HOME);
        return result;
      }
      enqueueSnackbar(result?.error?.message || MESSAGE.LOGIN_FAILED, { variant: "error" });
      return result;
    } catch (error) {
      enqueueSnackbar(error?.message || MESSAGE.LOGIN_FAILED, { variant: "error" });
    }
  };

  useEffect(() => {
    if (!isLoading && localStorage.getItem("token") && userMe?.data) {
      setUserMe(userMe.data);
      redirect(PATH.HOME);
    }
    if (!isLoading) {
      setLoadingAuth(false);
    }
  }, [userMe?.data, isLoading, redirect, setUserMe]);

  if ((isLoading || loadingAuth) && !userMeAuth) {
    return <LoadingComp />;
  }

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: 'url("/img/bg-login.png")',
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Box sx={{ maxWidth: "498px", textAlign: "center", p: "50px" }}>
        <fieldset
          style={{
            border: "1px solid rgba(255,255,255,0.5)",
            borderRadius: "24px",
            margin: 0,
          }}
        >
          <legend
            style={{
              padding: "0 12px",
              color: "var(--white)",
              fontWeight: "bold",
            }}
          >
            <img
              src="/img/logo.svg"
              alt=""
            />
          </legend>

          <Typography sx={{ fontSize: "24px", color: "var(--white)", pt: "30px" }}>HỆ THỐNG QUẢN LÝ KHO</Typography>
          <Typography sx={{ fontSize: "36px", color: "var(--white)", fontWeight: "bold" }}>ADMIN LOGIN</Typography>

          <Box sx={{ px: "50px", my: "30px" }}>
            <ReactHookFields
              colorText="var(--white)"
              onSubmit={handleSubmit(handleLogin)}
              txtConfirmBtn={MESSAGE.LOG_IN}
              control={control}
              errors={errors}
              listFields={loginFieldList}
              btnFullWidth={true}
              btnColor="black"
            />
          </Box>
        </fieldset>
      </Box>
    </Box>
  );
}
